import { jsx as _jsx } from "react/jsx-runtime";
import { getTiposSaidas } from './tipos_saidas_service';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 500 },
    {
        field: 'transferencia',
        headerName: 'Transferência',
        width: 200,
        valueGetter: function (_value, row) { return "".concat(row.transferencia ? 'Sim' : 'Não'); },
    },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export function TiposSaidasListar() {
    return _jsx(GridBase, { pagina: PAGINAS.TIPOS_SAIDAS, paginaPermissao: FUNCIONALIDADES.TIPOS_SAIDAS, rota: ROUTES.TIPOS_SAIDAS, fetchData: function (str, _filter, pag) { return getTiposSaidas(str, pag); }, columns: COLUNAS });
}
export default TiposSaidasListar;
